<template>
  <action-modal-wizard
    ref="modal"
    title="Insurance Document"
    modalIdPrefix="insurance-"
    :loan="loan"
    @form-completed="submit"
  >
    <tab-content title="Insurance Form" :before-change="validateForm">
      <insurance-form :model="model" ref="insuranceForm"/>
    </tab-content>
    <tab-content title="Additional files">
      <additional-files-form
        ref="additionalForm"
        headline="Please use the box below to upload Insurance files."
      />
    </tab-content>
  </action-modal-wizard>
</template>

<script>

import { TabContent } from 'vue-form-wizard';
import ActionModalWizard from '@/components/my_deals/actions/ActionModalWizard';
import InsuranceForm from '@/components/my_deals/actions/insurance/InsuranceForm';
import AdditionalFilesForm from '@/components/my_deals/actions/AdditionalFilesForm';
import helper from '@/libs/helper';

import MODEL from '@/components/my_deals/actions/insurance/resources/model.json';


export default {
  components: {
    ActionModalWizard,
    TabContent,
    AdditionalFilesForm,
    InsuranceForm,
  },
  props: {
    loan: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    model: helper.copy(MODEL),
  }),
  computed: {
    user() {
      return this.$store.getters.user;
    },
  },
  methods: {
    show() {
      this.reset();
      this.$refs.modal.show();
    },
    hide() {
      this.reset();
      this.$refs.modal.hide();
    },
    reset() {
      this.model = helper.copy(MODEL);
      this.$refs.additionalForm.reset();
    },
    validateForm() {
      return this.$refs.insuranceForm.validate();
    },
    submit() {
      const data = [];
      data.form = helper.copy(this.model);
      this.$refs.additionalForm.model.files.forEach(item => data.push(item));

      /* eslint no-underscore-dangle:  ["error", { "allow": ["_id"] }] */
      this.$reqs.uploadAssetManagement(`/users/${this.$store.getters.user.id}/loans/${this.loan._id}/insurance`, data)
        .then((response) => {
          this.$notify({ group: 'alert', text: 'Insurance files saved successfully.' });
          this.$emit('sent', response);
          this.hide();
        })
        .catch(() => {});
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/my_deals/actions/insurance/InsuranceWizzardModal.vue